import { render, staticRenderFns } from "./thirdlogin.vue?vue&type=template&id=c5cd4ab8&scoped=true&"
import script from "./thirdlogin.vue?vue&type=script&lang=js&"
export * from "./thirdlogin.vue?vue&type=script&lang=js&"
import style0 from "./thirdlogin.vue?vue&type=style&index=0&id=c5cd4ab8&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cd4ab8",
  null
  
)

export default component.exports